<template>
  <div class="sidebar">
    <div class="sidebar-header">
      <div class="logo-area">
        <div class="logo-circle msg-logo">
          <span class="logo-text">MSG</span>
        </div>
        <div class="company-info">
          <span class="company-name">{{ companyName }}</span>
        </div>
      </div>
    </div>

    <ul class="sidebar-menu">
      <li class="menu-item" :class="{ active: currentTab === 'msgOverview' }">
        <button @click="$emit('navigate', 'msgOverview')">
          <i class="fas fa-tachometer-alt"></i>
          <span>消息总览</span>
        </button>
      </li>

      <li class="menu-item" :class="{ active: currentTab === 'msgChat' }">
        <button @click="$emit('navigate', 'msgChat')">
          <i class="fas fa-comments"></i>
          <span>消息聊天</span>
          <span v-if="totalUnread > 0" class="nav-badge">{{ totalUnread > 99 ? '99+' : totalUnread }}</span>
        </button>
      </li>

      <li class="menu-item" :class="{ active: currentTab === 'msgContacts' }">
        <button @click="$emit('navigate', 'msgContacts')">
          <i class="fas fa-address-book"></i>
          <span>通讯录</span>
        </button>
      </li>

      <li class="menu-item" :class="{ active: currentTab === 'msgSearch' }">
        <button @click="$emit('navigate', 'msgSearch')">
          <i class="fas fa-search"></i>
          <span>消息搜索</span>
        </button>
      </li>
    </ul>

    <div class="sidebar-toggle" @click="toggleSidebar">
      <i class="fas fa-chevron-left"></i>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  currentTab: { type: String, default: 'msgOverview' }
})
defineEmits(['navigate'])

const companyName = ref('顾德智能')
const totalUnread = ref(15)

const toggleSidebar = () => {
  const sidebar = document.querySelector('.sidebar')
  if (sidebar) sidebar.classList.toggle('collapsed')
  const wrapper = document.querySelector('#wrapper')
  if (wrapper) wrapper.classList.toggle('collapsed')
}
</script>

<style scoped>
.sidebar {
  width: 220px;
  min-height: 100vh;
  position: fixed;
  top: 0;
  left: 60px;
  z-index: 1000;
  background: #1a2332;
  transition: width 0.3s ease;
  overflow-y: auto;
  overflow-x: visible;
}
.sidebar.collapsed { width: 50px; }
.sidebar-header {
  padding: 12px;
  background: #111827;
  display: flex;
  align-items: center;
}
.logo-area {
  display: flex;
  align-items: center;
  gap: 10px;
}
.logo-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0,0,0,0.3);
}
.msg-logo {
  background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
}
.logo-text {
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}
.company-info { display: flex; flex-direction: column; }
.company-name { color: #fff; font-size: 14px; font-weight: 600; white-space: nowrap; }
.sidebar.collapsed .company-info { display: none; }

.sidebar-menu { list-style: none; margin: 0; padding: 10px 0; }
.menu-item { position: relative; }
.menu-item > button {
  width: 100%;
  padding: 12px 20px;
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  transition: all 0.2s;
  text-align: left;
}
.menu-item > button:hover { background: rgba(255,255,255,0.05); color: #e2e8f0; }
.menu-item.active > button { color: #fff; background: rgba(6,182,212,0.15); border-left: 3px solid #06b6d4; }
.menu-item > button i { width: 18px; text-align: center; font-size: 14px; }

.nav-badge {
  margin-left: auto;
  background: #ef4444;
  color: #fff;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
  font-weight: 600;
}

.sidebar-toggle {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  cursor: pointer;
  color: #6b7280;
  padding: 10px;
  transition: color 0.2s;
}
.sidebar-toggle:hover { color: #fff; }
.sidebar-toggle i { font-size: 14px; }
</style>
